import React, { useContext, useState } from 'react';
import { Table, Typography, Button, Input, message, Spin } from 'antd';
import dayjs from 'dayjs';
import axios from 'axios';
import { useMovimientos } from '../../context/movimientosContext';
import { LoginContext } from '../../context/loginContext';

const { Title } = Typography;

export const ResumenMovimientos = ({ onFinish }) => {
  const { articulosMovimientos, selectedCliente, clearMovimientos } = useMovimientos();
  const { user } = useContext(LoginContext);
  const [observaciones, setObservaciones] = useState(''); // <- NUEVO
  const [loading, setLoading] = useState(false);

  const columns = [
    { title: 'Artículo', dataIndex: ['articulo', 'nombre'] },
    {
      title: 'Posiciones',
      render: (_, record) => (
        <ul style={{ margin: 0, paddingLeft: 18 }}>
          {record.posiciones.map((p, idx) => (
            <li key={idx}>
              {p.posicion}: {Number(p.cantidad).toFixed(2)} u · Lote: {p.lote || '—'} · Venc.: {p.fechaVencimiento ? dayjs(p.fechaVencimiento).format('YYYY-MM-DD') : '—'}
            </li>
          ))}
        </ul>
      )
    }
  ];

  const handleSubmit = async () => {
    setLoading(true);
    try {
      const payload = {
        idUsuario: selectedCliente._id,
        observaciones, // <- NUEVO (viaja al backend y al PDF)
        movimientos: articulosMovimientos.map(item => ({
          articulo: item.articulo._id,
          posiciones: item.posiciones.map(p => ({
            posicion: p.posicion,
            cantidad: p.cantidad,
            lote: p.lote ?? null,
            fechaVencimiento: p.fechaVencimiento ?? null,
          }))
        }))
      };

      const { data } = await axios.post(
        `${process.env.REACT_APP_API_URL}/movimientos/entrada/multiple`,
        payload,
        { headers: { Authorization: `Bearer ${user.token}` }, responseType: 'json' }
      );

      const { pdf, numeroRecibo } = data;

      // descargar PDF
      const byteCharacters = window.atob(pdf);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) byteNumbers[i] = byteCharacters.charCodeAt(i);
      const pdfBlob = new Blob([new Uint8Array(byteNumbers)], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(pdfBlob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `Recibo-${numeroRecibo}.pdf`;
      document.body.appendChild(link);
      link.click();
      setTimeout(() => {
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      }, 100);

      message.success('Movimientos registrados y recibo descargado exitosamente');
      clearMovimientos();
      onFinish && onFinish();
    } catch (e) {
      console.error(e);
      message.error('Error al registrar los movimientos');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Title level={4}>Resumen de Ingreso</Title>

      {/* Campo NUEVO de Observaciones */}
      <Input.TextArea
        placeholder="Observaciones para el recibo (opcional)"
        value={observaciones}
        onChange={(e) => setObservaciones(e.target.value)}
        rows={3}
        style={{ marginBottom: 16 }}
        maxLength={500}
        showCount
      />

      <Table
        columns={columns}
        dataSource={articulosMovimientos}
        rowKey={r => r.articulo._id}
        pagination={false}
      />

      <Button
        type="primary"
        onClick={handleSubmit}
        disabled={!selectedCliente || articulosMovimientos.length === 0 || loading}
        loading={loading}
        style={{ marginTop: 16 }}
      >
        Registrar Movimientos
      </Button>
    </>
  );
};

export default ResumenMovimientos;